import { useContext } from 'react'

import { DownloadDocumentsContext } from '../contexts/download-documents'

export const useDownloadDocuments = () => useContext(DownloadDocumentsContext)
